module.exports = __webpack_public_path__ + "media/images/tiedye/intro-section-f7746e161f1541322ee79da6b53e6c0e.png";